import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { HeaderOnelineMenuContainer } from "scmp-app/components/header/header-oneline-menu-container";
import { Container as HeaderOnelineMenuStyleContainer } from "scmp-app/components/header/header-oneline-menu-container/header-oneline-menu/header-oneline-menu-style/styles";

export const StyledHeaderOnelineMenuContainer = styled(HeaderOnelineMenuContainer)`
  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: flex;

    margin-inline: 20px;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    ${HeaderOnelineMenuStyleContainer} {
      margin-inline-start: 20px;
    }
  }
`;
